import { render, staticRenderFns } from "./Cb4xPxfMention.vue?vue&type=template&id=68207d4e&"
import script from "./Cb4xPxfMention.vue?vue&type=script&lang=js&"
export * from "./Cb4xPxfMention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68207d4e')) {
      api.createRecord('68207d4e', component.options)
    } else {
      api.reload('68207d4e', component.options)
    }
    module.hot.accept("./Cb4xPxfMention.vue?vue&type=template&id=68207d4e&", function () {
      api.rerender('68207d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/fragments/mobile/Cb4xPxfMention.vue"
export default component.exports